// @flow
import type { Org as ApiOrg } from 'api/orgAdmin';
import type { Action } from '../../actions/orgDashboard/orgs';

export type Org = {
  ...$Exact<ApiOrg>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: Org
  }
};

export default function orgs(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_ORG_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.orgId]: {
            ...state.byId[action.orgId],
            id: action.orgId,
            isFetching: true
          }
        }
      };
    case 'ORG_DASHBOARD_FETCH_ORG_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.org.id]: {
            ...action.org,
            isFetching: false
          }
        }
      };
    case 'ORG_DASHBOARD_DELETE_ORG': {
      const newState = { ...state };
      delete newState.byId[action.orgId];
      return newState;
    }
    case 'ORG_DASHBOARD_PARTIAL_UPDATE_ORG': {
      return {
        byId: {
          ...state.byId,
          [action.values.id]: {
            ...state.byId[action.values.id],
            ...action.values
          }
        }
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
